import { useContext, useEffect, useRef, useState } from "react";
import { ADModalBodyNoScroll, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { DC } from "src/dataCollector/DataCollector";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState";
import { GlassInputControl } from "./GlassInput";
import { Spinner } from "react-bootstrap";
import { ApplicationStateContext } from "src/states/ApplicationState";
import { AsyncCache } from "src/dataCollector/ViaKUCollector";
import { JsonViewer } from "src/modules/JobModule/JsonViewer";


export function KortudsnitViewer(props: { window: ManagedWindow }) {
   let [data, setData] = useState<any | null>(null);
   let ref = useRef<AsyncCache>(new AsyncCache(DC.ViaKU.mtrkInfo));
   let [page, setPage] = useState<number>(0);
   let [enviroment, setEnviroment] = useState<string | "">("");
   let { hasAccessToFeature } = useContext(ApplicationStateContext)
   let { dispatch } = useWindowContext();

   useEffect(() => {
      ref.current.get(props.window.windowParams?.ejerlav, props.window.windowParams?.matrikelNr, enviroment || undefined).then((res) => {
         console.log("mtrkInfo", res)
         setData(res as unknown as any)
      });
      return () => {
         setData(null)
      }
   }, [props.window.windowParams?.ejerlav, props.window.windowParams?.matrikelNr, enviroment])

   function pageToData() {
      if (!data) return ""
      if (page === 0) {
         return data.oversigtskort ?? ""
      } else {
         if (page > data.matrikelklynger?.length) return data.matrikelklynger.at(-1)?.b64_svgz ?? ""
         return data.matrikelklynger?.[page - 1]?.b64_svgz ?? ""
      }
   }

   return (
      <AdvancedDragModal
         window={props.window}
         title={"Kortudsnit"}
         onClose={() => dispatch(closeWindow(props.window.id))}
         PosDefault={{ width: "600px", height: "800px", top: "50%", left: "calc(100% - 10px)", transform: "translate(-100%, -50%)" }}
      >
         <ADModalBodyNoScroll templateRows={"1fr"}>
            <div style={{ position: "absolute", top: 10, left: 10, zIndex: 100, fontSize: "10px", display: "flex", gap: "5px" }} >
               <GlassInputControl>
                  <select value={page} onChange={(e) => setPage(parseInt(e.target.value))}>
                     <option value={0}>Oversigtskort</option>
                     {data?.matrikelklynger?.map((klynge, index) => (
                        <option key={index} value={index + 1}>Klynge {index + 1}</option>
                     ))}
                  </select>
               </GlassInputControl>
               {hasAccessToFeature("Debugging") &&
                  <GlassInputControl>
                     <select value={enviroment} onChange={(e) => setEnviroment(e.target.value)}>
                        <option value={""}>Default</option>
                        <option value={"production"}>Production</option>
                        <option value={"staging"}>Staging</option>
                        <option value={"test"}>Test</option>
                     </select>
                  </GlassInputControl>
               }
            </div>
            {data ?
               <>
                  <img src={"data:image/svg+xml;base64," + pageToData()} style={{ width: "100%", height: "auto" }} alt="Kortudsnit" />
                  <div style={{ position: "absolute", top: 60, left: 10, zIndex: 100, fontSize: "10px", maxHeight: "90%", overflowY: "auto", width: "calc(100% - 20px)" }} >
                     <div style={{ pointerEvents: "none" }} >
                        <JsonViewer parsedJson={data} level={0} keyFilter={(key) => !["oversigtskort", "b64_svgz"].includes(key)} />
                     </div>
                  </div>
               </>
               : <Spinner animation="border" role="status" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                  <span className="visually-hidden">Loading...</span>
               </Spinner>
            }
         </ADModalBodyNoScroll>
      </AdvancedDragModal>
   )
}
